<template>
  <div class="pageContol listWrap templateList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">培训管理</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">数据中心</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="operationControl flexdc" style="align-items: flex-start">
          <div class="searchbox">
            <div title="年月" class="searchboxItem ci-full">
            <span class="itemLabel">年月:</span>
             <el-date-picker
                size="small"
                v-model="retrievalData.month"
                type="month"
                value-format="yyyy-MM"
                placeholder="请选择年月">
              </el-date-picker>
            </div>
            <div class="df">
              <el-button type="primary" class="bgc-bv" round @click="getData()">查询</el-button>
              <el-button type="primary" class="bgc-bv" round @click="exportRecords()">导出</el-button>
            </div>
          </div>
        </div>
        <div class="framePage-scroll">
          <div class="ovy-a">
            <el-table ref="multipleTable" :data="tableData" :height="tableHeight" size="small" tooltip-effect="dark"
              style="width: 100%" :header-cell-style="tableHeader" stripe>
              <el-table-column label="序号" align="center" type="index" :index="indexMethod" fixed />
              <el-table-column label="外委单位名称" prop="compName" align="left"/>
              <el-table-column label="课程名称" prop="courseName" align="left"/>
              <el-table-column label="培训类型" prop="trainTypeNamePath" align="left"/>
              <el-table-column label="购买数量" prop="payCount" align="left"/>
              <el-table-column label="参训人数" prop="userCount" align="left"/>
              <el-table-column label="合格人数" prop="passCount" align="left"/>
              <el-table-column label="不合格人数" prop="unPassCount" align="left"/>
              <Empty slot="empty" />
            </el-table>
          </div>
        </div>
        <PageNum :apiData="apiData" @sizeChange="sizeChange" @getData="getData" />
      </div>
    </div>
  </div>
</template>
<script>
const className = "eduCertService";
import Empty from "@/components/Empty.vue";
import PageNum from "@/components/PageNum.vue";
import List from "@/mixins/List";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  name: "classListCtrY",
  components: {
    Empty,
    PageNum,
  },
  mixins: [List],
  data() {
    return {
      // 检索数据
      retrievalData: {
        month: "", //月份
      },
    };
  },
  created() { },
  watch: {
    
  },
  computed: {
    ...mapGetters({
      downloadItems: "getDownloadItems",
    }),
  },
  mounted() {
    
  },
  methods: {
    // 导出暂停学习的记录
    exportRecords() {
      this.$post("/biz/project/hospital/pay/export", {
        month: this.retrievalData.month,
      }).then((res) => {
        if (res.status == "0") {
          for (let item of res.data) {
            if (!this.downloadItems.includes(item.taskId)) {
              this.$store.dispatch("pushDownloadItems", item.taskId);
            } else {
              this.$message.warning(
                "[" + item.fileName + "]已经申请下载,请耐心等待"
              );
            }
          }
        } else {
          this.$message.error(re.message);
        }
      });
    },
    // 获取 - 列表数据
    getData(pageNum = 1) {
      const params = {
        pageNum: pageNum,
        pageSize: this.pageSize,
        ...this.retrievalData,
      }
      this.doFetch({
        url: "/biz/project/hospital/pay/pageList",
        params,
        pageNum,
      });
    },
  },
};
</script>
<style lang="less" scoped>
</style>
